import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
//import { GrowlModule } from 'primeng/growl';
import { InputTextModule } from 'primeng/inputtext';
import { BlockUIModule } from 'primeng/blockui';
import { SpinnerModule } from 'primeng/spinner';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { KeyFilterModule } from 'primeng/keyfilter';
//import {  FileUploadModule, InputMaskModule, ColorPickerModule } from 'primeng/primeng';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MaFormadePagoService } from './maformadepago/servicio/maformadepago.servicio';
import { AcSucursalService } from './acsucursal/servicio/acsucursal.servicio';
import { MaUnidadNegocioService } from './maunidadnegocio/servicio/maunidadnegocio.servicio';

@NgModule({
    declarations: [
     
    ],
    imports: [CommonModule,
        //InputMaskModule,
        FormsModule,
        TableModule, PanelModule,  BlockUIModule,
        InputTextModule, ButtonModule, DropdownModule,
        SpinnerModule, CalendarModule, CheckboxModule,
        ConfirmDialogModule, TabViewModule, FieldsetModule,
        //FileUploadModule, 
        KeyFilterModule,
        DialogModule, RadioButtonModule,
        //ColorPickerModule
    ],
    exports: [],
    providers: [ConfirmationService,
        MaFormadePagoService,
        AcSucursalService,
        MaUnidadNegocioService,],
})
export class CoreModule { }
